import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useToast } from '../components/common/ToastProvider';

const fmt = (v) =>
  `₹${parseFloat(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function blockedMessage(entry) {
  return `${entry.instrument} skipped — ${entry.rule || 'blocked by stacking policy'}`;
}

function clampedMessage(entry) {
  return `${entry.instrument} reduced from ${fmt(entry.from)} to ${fmt(entry.to)} — ${entry.rule}`;
}

// Fires one warning toast per stacking_trace.blocked/clamped entry the last
// order mutation produced. stacking_trace is present (possibly empty) on
// every order response — this hook stays silent for the common empty case
// and dedupes against the previous trace so unrelated re-renders (RTK Query
// refetches of the same order) never re-toast the same content.
export function useStackingTraceToasts() {
  const showToast = useToast();
  const stackingTrace = useSelector((s) => s.order.stacking_trace);
  const lastSignatureRef = useRef('');

  useEffect(() => {
    const blocked = stackingTrace?.blocked || [];
    const clamped = stackingTrace?.clamped || [];
    if (blocked.length === 0 && clamped.length === 0) return;

    const signature = JSON.stringify({ blocked, clamped });
    if (signature === lastSignatureRef.current) return;
    lastSignatureRef.current = signature;

    blocked.forEach((entry) => showToast(blockedMessage(entry), 'warning'));
    clamped.forEach((entry) => showToast(clampedMessage(entry), 'warning'));
  }, [stackingTrace, showToast]);
}
